import React from 'react';

export default function () {
    return (
        <div className="introduction">
            <p>
                The Entity Recognition Demo is a semantic extraction tool based on a knowledge graph and machine learning algorithms for Named Entity Recognition (NER). 
                It is designed to show the capabilities of the PoolParty Extractor regarding the extraction of concepts, terms, and previously trained named entity recognizers. 
                By also including trained classifiers from the Semantic Classifier this tool also shows how documents can be categorized.
            </p>
            <p>
                To use this tool simply enter some text or choose one of the text snippets, select a Named Entity Recognizer, and click on <strong>Extract</strong> to detect the following:
            </p>
            <ul>
                <li>
                    <strong>Named Entities</strong>, extracted through <strong>NER</strong> (Named Entity Recognition) based on machine learning algorithms.
                </li>
                <li>
                    <strong>Concepts</strong>, extracted through <strong>Concept extraction</strong> based on PoolParty Extractor.
                </li>
                <li>
                    <strong>Important terms</strong>, identified through statistical text analysis.
                </li>
                <li>
                    <strong>Document genre</strong>, identified by ML-based classification algorithms.
                </li>
            </ul>
            <p>
                You can also modify the maximum number of concepts and terms that are extracted from the text. 
                The default value for both terms and concepts is 25.
            </p>
        </div>
    );

}
